import React from "react";
import { Box, Typography, Checkbox } from "@mui/material";

const ModuleSelection = ({ modules, selectedModules, onModuleSelection, errors, calculateTotal }) => {
  return React.createElement(
    Box,
    { sx: { width: '100%' } },
    React.createElement(Typography, { variant: "h6", gutterBottom: true }, "Select Modules"),
    errors.selectedModules && React.createElement(
      Typography,
      { color: "error", paragraph: true },
      errors.selectedModules
    ),
    modules.length === 0 ? (
      React.createElement(
        Typography,
        { color: "error" },
        "No modules available. Please try again later."
      )
    ) : (
      React.createElement(
        Box,
        { sx: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 2 } },
        modules.map((module) =>
          React.createElement(
            Box,
            {
              key: module.id,
              sx: {
                p: 2,
                border: '1px solid',
                borderColor: selectedModules.includes(module.id) ? 'primary.main' : 'divider',
                borderRadius: 1,
                cursor: 'pointer',
                '&:hover': { borderColor: 'primary.main' }
              },
              onClick: () => onModuleSelection(module.id)
            },
            React.createElement(
              Box,
              { sx: { display: 'flex', justifyContent: 'space-between' } },
              React.createElement(Typography, { fontWeight: "bold" }, module.name),
              selectedModules.includes(module.id) && React.createElement(Checkbox, {
                checked: selectedModules.includes(module.id),
                onChange: () => onModuleSelection(module.id),
                color: "primary"
              })
            ),
            React.createElement(
              Typography,
              { variant: "body2", color: "text.secondary" },
              module.description
            ),
            React.createElement(
              Typography,
              { variant: "body1", mt: 1 },
              `Price: N$${typeof module.price === 'number' ? module.price.toFixed(2) : '0.00'}`
            )
          )
        )
      )
    ),
    React.createElement(
      Box,
      { sx: { mt: 4, p: 2, bgcolor: 'background.paper', borderRadius: 1 } },
      React.createElement(Typography, { variant: "h6" }, `Selected Modules: ${selectedModules.length}`),
      React.createElement(
        Typography,
        { variant: "h6" },
        `Total Amount: N$${typeof calculateTotal() === 'number' ? calculateTotal().toFixed(2) : '0.00'}`
      )
    )
  );
};

export default ModuleSelection;